import CoachFacilities from './coach-facilities'

export default CoachFacilities
